/**
 * 計算字串的視覺寬度（中文字 = 2，英文/數字/符號 = 1）
 */
const getVisualWidth = (str: string): number => {
  let width = 0
  for (const char of str) {
    // CJK 統一表意文字、全形符號、標點等範圍視為寬字元
    width +=
      /[\u1100-\u115F\u2E80-\u303E\u3041-\u33BF\u33FF-\uA4CF\uAC00-\uD7AF\uF900-\uFAFF\uFE10-\uFE1F\uFE30-\uFE6F\uFF01-\uFF60\uFFE0-\uFFE6]/.test(
        char
      )
        ? 2
        : 1
  }
  return width
}

/**
 * 根據標籤名稱最大視覺寬度，動態決定 radio group 的欄數
 * （中文字計 2、英文/數字計 1）
 *
 * | 最大視覺寬度 | 欄數 |
 * |------------|------|
 * | ≤12        | 3    |
 * | 13-24      | 2    |
 * | >24        | 1    |
 */
export const getRadioColumns = (tags: { subtagName?: string | null }[]): number => {
  if (!tags || tags.length === 0) {
    return 3
  }
  const maxWidth = Math.max(...tags.map((t) => getVisualWidth(t.subtagName ?? '')))
  if (maxWidth > 24) {
    return 1
  }
  if (maxWidth > 12) {
    return 2
  }
  return 3
}
